import { render, staticRenderFns } from "./SidebarPanelHeader.vue?vue&type=template&id=3681b9c6&"
import script from "./SidebarPanelHeader.vue?vue&type=script&lang=js&"
export * from "./SidebarPanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./SidebarPanelHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports